import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

export const PostSlider = ({ posts, description = false }) => {
    return (
        <Container>
            <Row className="g-2">
                {
                    posts.map(post => (
                        <Col key={post.slug} xs={12} md={6} lg={4}>
                            <PostSlideItem post={post} description={description} key={post.slug} />
                        </Col>
                    ))
                }
            </Row>
        </Container>
    )
}


const PostSlideItem = ({ post, description = false }) => {
    const navigate = useNavigate();
    const handlePostClick = useCallback((slug) => navigate(`/blog/${slug}`), [navigate]);
    
    return (
        <div className="h-100 border border-blue p-0 post-slide-item" onClick={()=> handlePostClick(post.slug)}>
            <img src={post.image} alt={`cover post for ${post.title}`} className="img-fluid post-slide-img" />
            <div className="p-3 pt-4">
                <h2>{ post.title }</h2>
                { description && <div className="mb-4">{ post.description }</div> }
            </div>
        </div>
    )
}